
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { setAlert } from "store/alerts-slice";
import api from 'helpers/api';
import Loader from 'components/miscellaneous/Loader/Loader';
import Input from 'pages/Book/ClientBook/UI/Input/Input';

const DeleteAppointment = ({ appointment, close }) => {
    const dispatch = useDispatch();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ notifyPatient, setNotifyPatient ] = useState(true);

    const doDelete = async () => {
        setIsLoading(true);
        try {
            const res = await api.delete(`/booking/${appointment.token}?notify=${notifyPatient}`);
            if (res.success && res.data.success) {
                dispatch(setAlert({ type: 'success' }))
                close(true);
            } else {
                dispatch(setAlert({ type: 'error' }))
            }
        } catch (e) {
            dispatch(setAlert({ type: 'error' }))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            { isLoading && <div style={ {
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                backgroundColor: '#ffffff87',
                top: 0,
                left: 0
            } }>
                <Loader color="#ddd" />
            </div> }
            <div style={{marginBottom: 25, marginTop: 25}}>
                <h3 style={ { margin: 0 } }>Are you sure you want to delete this appointment?</h3>
                <Input type="checkbox" value={ notifyPatient } onValueChange={ setNotifyPatient } label={ "Notify patient about the cancallation" } />
            </div>
            <div className="d-flex">
                <button className='link-button' style={ { marginLeft: 'auto' } } onClick={ () => close(false) }>Cancel</button>
                <button className='alma-button' onClick={ doDelete }>Delete</button>
            </div>
        </>
    )
}

export default DeleteAppointment